module.exports = __webpack_public_path__ + "img/japanese-“congratulations”-button.ae9e3535.png";